// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"BlurModal-backdrop","container":"BlurModal-container","logo":"BlurModal-logo","title":"BlurModal-title","body":"BlurModal-body","blurButton":"BlurModal-blurButton"};